import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { ChangeDigitalSignatureProcessClientResponse } from '../@types/ChangeDigitalSignatureProcess'

type Store = {
  changeDigitalSignatureProcess: ChangeDigitalSignatureProcessClientResponse | null
  setChangeDigitalSignatureProcess: (
    value: ChangeDigitalSignatureProcessClientResponse,
  ) => void
}

export const useChangeDigitalSignatureProcessStore = create<Store>()(
  devtools(
    (set) => ({
      changeDigitalSignatureProcess: null,
      setChangeDigitalSignatureProcess: (changeDigitalSignatureProcess) =>
        set({ changeDigitalSignatureProcess }),
    }),
    { name: 'ChangeDigitalSignatureProcessStore' },
  ),
)
